import 'css-chunksrc/client/common/taskCompletionStatus/styles.scss';export default {
  "taskCompletionStatus": "_taskCompletionStatus_1wndm_1",
  "late": "_late_1wndm_14",
  "progressed": "_progressed_1wndm_18",
  "completed": "_completed_1wndm_22",
  "disabled": "_disabled_1wndm_39",
  "constrained": "_constrained_1wndm_50",
  "userChecking": "_userChecking_1wndm_61"
};